// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"styles_logoContainer__2AHMN","logo":"styles_logo__3Hs01"};